// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ylfloGt1YaOhMVG2AeJL {
    padding: 0 16px;
    display: flex;
    gap: 10px;
    align-items: center;
    height: 37px;
}

.GsrO53XF7i9XWPUUpeuv {
    max-width: 200px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.J4Q4BGqGvSBfAD6jUzPa {
    display: flex;
    align-items: center;
    gap: 12px;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/Layout/Header/HeaderDesktop/HeaderDesktop.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb","sourcesContent":[".actions {\n    padding: 0 16px;\n    display: flex;\n    gap: 10px;\n    align-items: center;\n    height: 37px;\n}\n\n.userMenu {\n    max-width: 200px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n}\n\n.menuItem {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actions": `ylfloGt1YaOhMVG2AeJL`,
	"userMenu": `GsrO53XF7i9XWPUUpeuv`,
	"menuItem": `J4Q4BGqGvSBfAD6jUzPa`
};
export default ___CSS_LOADER_EXPORT___;
